import * as yup from "yup"
import { isValidIsraeliID } from "../../ui/DynamicForm/utils/validations/isValidIsraeliID"
import {
  createCarNumberValidation,
  createEmailValidation,
  createExtendedPhoneValidation,
  createIsraeliIdValidation,
  createOptionalNumericValidation,
  createOptionalTextValidation,
  createRequiredValidation,
} from "./formValidationUtils"

/**
 * Validation schema for the Accident Report Form
 */
export const accidentReportValidationSchema = yup.object().shape({
  privateName: createRequiredValidation("שדה חובה"),

  sureName: createRequiredValidation("שדה חובה"),

  mobile: createExtendedPhoneValidation("שדה חובה", "מספר טלפון לא תקין", 9),

  identityNumber: createIsraeliIdValidation(
    "שדה חובה",
    "מספר תעודת זהות לא תקין",
    isValidIsraeliID,
  ),

  email: createEmailValidation("שדה חובה", "כתובת דוא״ל לא תקינה"),

  licenseNumber: createCarNumberValidation("שדה חובה", "מספר רכב לא תקין"),

  // Optional fields - not required but validated if provided
  insuranceCompanyName: createOptionalTextValidation(
    "נא להזין רק אותיות בעברית",
  ),

  policyNumberThirdParty: createOptionalNumericValidation("נא להזין רק מספרים"),

  eventDescription: createOptionalTextValidation("נא להזין רק אותיות בעברית"),

  damageDescription: createOptionalTextValidation("נא להזין רק אותיות בעברית"),
})

/**
 * Default values for the form fields
 */
export const accidentReportDefaultValues = {
  privateName: "",
  sureName: "",
  mobile: "",
  identityNumber: "",
  email: "",
  licenseNumber: "",
  insuranceCompanyName: "",
  policyNumberThirdParty: "",
  eventDescription: "",
  damageDescription: "",
}

/**
 * Type definition for the form data
 */
export interface AccidentReportFormData {
  privateName: string
  sureName: string
  mobile: string
  identityNumber: string
  email: string
  licenseNumber: string
  insuranceCompanyName: string
  policyNumberThirdParty: string
  eventDescription: string
  damageDescription: string
}
